module.exports = __webpack_public_path__ + "static/img/yi1.7cb84c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yi1.png
// module id = +x/B
// module chunks = 0